var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.273 3h-30c-.83 0-1.5.67-1.5 1.5v39c0 .83.67 1.5 1.5 1.5h30c.83 0 1.5-.67 1.5-1.5v-39c0-.83-.67-1.5-1.5-1.5zm-1.875 38.625h-26.25v-9.422h4.59a9.095 9.095 0 0 0 2.77 3.97 9.079 9.079 0 0 0 5.765 2.077 9.052 9.052 0 0 0 8.536-6.047h4.59V29.25h-6.957l-.244 1.158c-.562 2.803-3.056 4.842-5.925 4.842a6.066 6.066 0 0 1-5.93-4.842L18.1 29.25h-6.952V6.375h26.25v35.25zm-22.125-25.64h18a.376.376 0 0 0 .375-.376v-2.25a.376.376 0 0 0-.375-.375h-18a.376.376 0 0 0-.375.375v2.25c0 .207.17.375.375.375zm0 7.5h18a.376.376 0 0 0 .375-.376v-2.25a.376.376 0 0 0-.375-.375h-18a.376.376 0 0 0-.375.375v2.25c0 .207.17.375.375.375z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileText);
export default __webpack_public_path__ + "static/media/file-text.9d5bba52a56c22a0cace8b17fd867d17.svg";
export { ForwardRef as ReactComponent };